import { defineComponent as _defineComponent } from 'vue'
import kebabCase from "lodash/kebabCase";
import QueryParams, {Configuration} from "@/app/helpers/QueryParams";
import {computed} from "vue";
import {useRouter} from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareButtonsCard',
  props: {
    config: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
};



const router = useRouter()

const queryParams = computed(() => QueryParams.build(props.config))

const configurationUrl = computed(() => {
  let query = QueryParams.build(props.config)

  // @ts-ignore
  return window.location.origin + router.resolve({query}).href
})


return { __sfc: true,props, router, queryParams, configurationUrl, kebabCase }
}

})